import Container from "react-bootstrap/Container";
import FormSection from "../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../components/Faq";
import "../styles/dualEducation.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function Eletbiztositas() {
  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">ÉLETBIZTOSÍTÁS • CSALÁDI BIZTONSÁG</span>

        <h1 className="title">
          Életbiztosítás <br />
          <span style={{ color: "#c7d2fe" }}>a családod biztonságáért</span>
        </h1>

        <p className="subtitle">
          Az életbiztosítás anyagi biztonságot nyújt a családodnak váratlan
          élethelyzetekben, illetve segíthet hosszú távú megtakarítási céljaid
          elérésében is, a választott konstrukciótól függően.
          <br />
          <span className="fw-bold">
            Nézd meg, milyen típusok közül választhatsz, és kérj személyre
            szabott ajánlatot!
          </span>
        </p>

        <div className="cta">
          <Button href="#tipusok" className="btn btn-primary">
            Típusok megtekintése
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Ajánlatot kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">Kockázati</div>
                <div className="muted">Tisztán biztosítási védelem</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Megtakarítási</div>
                <div className="muted">Védelem és tőkefelhalmozás együtt</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">Testre szabható</div>
                <div className="muted">Összeg és kiegészítők egyénileg</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="tipusok" className="section">
          <h2 className="h2">Milyen életbiztosítás típusok léteznek?</h2>
          <p className="lead">
            A választott típus attól függ, hogy elsősorban védelmet, vagy
            emellett hosszú távú megtakarítást is szeretnél-e a biztosításba
            építeni.
          </p>

          <Row className="g-3 mt-2">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Kockázati életbiztosítás</h3>
                <p className="small">
                  Jellemzően alacsonyabb díj mellett nyújt anyagi védelmet a
                  kedvezményezetteknek haláleset esetén; sokszor
                  hitelfedezetként is szolgál.
                </p>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="card h-100">
                <h3>Megtakarítási / befektetési biztosítás</h3>
                <p className="small">
                  A védelem mellett tőkét is felhalmoz a futamidő alatt,
                  jellemzően választható befektetési eszközökkel és hosszabb
                  futamidővel.
                </p>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="folyamat" className="section">
          <h2 className="h2">Így köthetsz életbiztosítást</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Igény felmérése</p>
                <p className="small">
                  Átbeszéljük, mire van elsősorban szükséged
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Típus kiválasztása</p>
                <p className="small">
                  Kockázati vagy megtakarítási konstrukció javaslata
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Ajánlatkérés</p>
                <p className="small">
                  Több biztosítótól kérünk számodra konkrét ajánlatot
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Szerződéskötés</p>
                <p className="small">
                  A kiválasztott ajánlat alapján megkötjük a szerződést
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérjen személyre szabott ajánlatot!</h2>
          <p className="lead small">
            Add meg az adataid, és segítünk kiválasztani a családodhoz illő
            életbiztosítást.
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Életbiztosítás" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes tanácsadás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több biztosító ajánlata egy helyen</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Testre szabott összeg és kiegészítők</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Bankfüggetlen, elfogulatlan tanácsadás</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Kinek érdemes életbiztosítást kötnie?",
                    answer:
                      "Elsősorban azoknak, akiktől mások (pl. gyermek, házastárs) anyagilag függenek, illetve akiknek hitele van, és a törlesztést a biztosítással is fedezni szeretnék váratlan esemény esetén.",
                  },
                  {
                    question:
                      "Mi a különbség a kockázati és a megtakarítási biztosítás között?",
                    answer:
                      "A kockázati biztosítás kizárólag védelmet nyújt, lejáratkor jellemzően nincs kifizetés, ha nem történt biztosítási esemény. A megtakarítási/befektetési biztosítás emellett tőkét is felhalmoz, amit a futamidő végén vagy visszavásárláskor felvehetsz.",
                  },
                  {
                    question: "Mennyi legyen a biztosítási összeg?",
                    answer:
                      "Ez jövedelemtől, fennálló hitelektől és az eltartottak számától függ — a tanácsadás során segítünk meghatározni a helyzetedhez illő védelmi szintet.",
                  },
                ],
              },
            ]}
          />

          <p className="small mt-4">
            A fenti tartalom tájékoztató jellegű, nem minősül biztosítási
            szerződéskötési ajánlatnak. A Financials.hu nem biztosító; a
            pontos feltételeket, díjakat és kizárásokat mindig a választott
            biztosító szerződési feltételei határozzák meg.
          </p>
        </section>
      </Container>
    </>
  );
}
